import { breakpoint } from '@/style';

/**
 * Breakpoint für die Komponente Mobile <-> Desktop
 */
export const ELEMENT_BREAKPOINT = breakpoint.large;
